export const models = {
  application: 'application',
  withdrawal: 'withdrawal',
  project: 'project'
};
